import React from 'react';

import { useQueryClient } from 'react-query';

const withQueryClient = (Component) => {
  const QueryClientWrapper = (props) => {
    const queryClient = useQueryClient();

    return <Component queryClient={queryClient} {...props} />;
  };

  return QueryClientWrapper;
};

export default withQueryClient;
